import { useState } from "react";
import { hotComments } from "@/mocks/homeData";

const toneClass: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  secondary: "bg-secondary-100 text-secondary-700",
  accent: "bg-accent-100 text-accent-700",
};

export default function CommentWall() {
  const [liked, setLiked] = useState<Record<number, boolean>>({});

  const toggleLike = (index: number) => {
    setLiked((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  return (
    <section id="comments" className="bg-secondary-50 py-14 md:py-24">
      <div className="px-4 md:px-10 max-w-6xl mx-auto">
        <div className="max-w-2xl">
          <span className="text-secondary-700 text-xs md:text-sm tracking-[0.2em] uppercase">
            GUA · TALK
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            吃瓜现场 · 热评墙
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            热帖好不好看，评论区最诚实。这里收录当天点赞攀升最快的吃瓜发言，围观群众的观点往往比标题更精彩。
          </p>
        </div>

        <div className="mt-9 md:mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {hotComments.map((comment, index) => (
            <article
              key={comment.user + comment.time}
              className={`rounded-lg p-5 md:p-6 flex flex-col ${
                comment.pinned
                  ? "bg-primary-950 text-background-100"
                  : "bg-background-50 border border-secondary-100"
              }`}
            >
              <div className="flex items-center gap-3">
                <span
                  className={`w-10 h-10 shrink-0 rounded-full flex items-center justify-center font-heading font-bold text-sm ${toneClass[comment.tone]}`}
                >
                  {comment.initial}
                </span>
                <div className="min-w-0">
                  <p
                    className={`text-sm font-medium truncate ${
                      comment.pinned ? "text-background-50" : "text-foreground-950"
                    }`}
                  >
                    {comment.user}
                  </p>
                  <p
                    className={`text-xs mt-0.5 ${
                      comment.pinned ? "text-background-300" : "text-foreground-500"
                    }`}
                  >
                    {comment.time}
                  </p>
                </div>
                {comment.pinned && (
                  <span className="ml-auto px-2 py-0.5 rounded bg-accent-500 text-foreground-950 text-[10px] font-medium whitespace-nowrap">
                    置顶热评
                  </span>
                )}
              </div>

              <p
                className={`mt-4 text-sm leading-relaxed flex-1 ${
                  comment.pinned ? "text-background-100" : "text-foreground-700"
                }`}
              >
                {comment.text}
              </p>

              <div
                className={`mt-5 pt-4 flex items-center gap-5 text-xs border-t ${
                  comment.pinned
                    ? "border-background-50/15 text-background-300"
                    : "border-secondary-100 text-foreground-500"
                }`}
              >
                <button
                  type="button"
                  onClick={() => toggleLike(index)}
                  className={`inline-flex items-center gap-1.5 cursor-pointer transition-colors ${
                    liked[index]
                      ? "text-primary-500"
                      : comment.pinned
                        ? "hover:text-background-50"
                        : "hover:text-primary-600"
                  }`}
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className={liked[index] ? "ri-heart-fill" : "ri-heart-line"}></i>
                  </span>
                  {comment.likes + (liked[index] ? 1 : 0)}
                </button>
                <span className="inline-flex items-center gap-1.5">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-chat-3-line"></i>
                  </span>
                  {comment.replies}
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}